import { currenciesConstants } from "../constants/action.constants";

const initialState = {
  submitting: false,
  submitted: false,
  request: null,
  response: null,
  error: null
};

export const addCurrency = (state = initialState, action) => {
  switch (action.type) {
    case currenciesConstants.ADD_CURRENCY_REQUEST:
      return {
        ...state,
        submitting: true,
        submitted: false,
        request: action.requestBody,
        response: null,
        error: null
      };
    case currenciesConstants.ADD_CURRENCY_SUCCESS:
      return {
        ...state,
        submitting: false,
        submitted: true,
        response: action.response,
        error: null
      };
    case currenciesConstants.ADD_CURRENCY_FAILURE:
      return {
        ...state,
        submitting: false,
        submitted: false,
        response: null,
        error: action.error
      };
    case currenciesConstants.ADD_CURRENCY_RESET:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
